import { createContext, useContext, useState, useEffect } from "react"
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles"
import createDynamicTheme from "./theme" // Update path to match your project structure
import { useGetThemesQuery } from "../../src/pages/dashboard/services" // Update path to match your project structure

// Create context with default values
const ThemeContext = createContext({
  themeData: null,
  isThemeLoading: true,
})

export const useThemeContext = () => useContext(ThemeContext)

export function ThemeProvider({ children }) {
  const { data, isLoading } = useGetThemesQuery()
  const [dynamicTheme, setDynamicTheme] = useState(createDynamicTheme({}))

  // Update theme when data changes
  useEffect(() => {
    if (data?.data) {
      setDynamicTheme(createDynamicTheme(data.data))
    }
  }, [data])

  // Context value
  const contextValue = {
    themeData: data?.data || null,
    isThemeLoading: isLoading,
  }

  return (
    <ThemeContext.Provider value={contextValue}>
      <MuiThemeProvider theme={dynamicTheme}>{children}</MuiThemeProvider>
    </ThemeContext.Provider>
  )
}
